export default __webpack_public_path__ + "static/media/nu.c466a92d.svg";